export default {
  'goldkid-rejectAB:title': 'Kaspi Gold для ребенка уже открыт. Получите карту.',
  'goldkid-rejectAB-steps:title': 'Чтобы получить или перевыпустить <br> Kaspi Gold для ребенка,',
  'goldkid-rejectAB-steps:step1': '<b>Родителю</b> необходимо подойти в любое <a href="https://kaspi.kz/maps/branches/?has_cardomat=True&closest=True">отделение Kaspi.kz</a>',
  'goldkid-rejectAB-steps:step2': 'Получить карту Kaspi Gold в картомате при помощи Kaspi QR',
  'goldkid-rejectAB-steps:step3': 'Передать карту и ПИН-код <b>ребенку.</b>',
  'goldkid-rejectAB:btn': 'Ближайшее отделение Kaspi.kz'
}
